/* @flow */
import graficoDeColunas from '../utils/grafico-de-colunas';
import traduzirDiasDaSemana from '../utils/traduzir-dias-da-semana';

type Data = {
    diaSemana: string,
    quantidade: number,
};

const gerarGraficoPorDiasDaSemana = (diaDaSemana: Data[]) => {
    graficoDeColunas({
        resultado: diaDaSemana.map(dia => [`${traduzirDiasDaSemana(dia.diaSemana)}`, dia.quantidade]),
        id: 'grafico-dia-da-semana',
        coluna: ['Dia da semana', 'Quantidade'],
    });
};

export default gerarGraficoPorDiasDaSemana;
